import { getBaseURL } from '@vue/store/helpers.js';
import axios from "axios";

export const submitAgentContactForm = ({ params }, agentId) => {
    return new Promise((resolve, reject) => {
        try {
            if(!params) { reject('Agent Contact API :: submitAgentContactForm :: Invalid Form Params :', params); return false; }
            let requestURL = getBaseURL() + `/api/v1/agents/${agentId}/contact`;
            axios.post(requestURL, params)
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject(err);
                });
        } catch (error) {
            reject(error);
        }
    });
}